import { i18n } from "../../i18n";
import { PrimaryButton } from "../Buttons/PrimaryButton";
import { closeModal } from "./Modal";

declare let window: ProductPage;

export const DutiesInformationModalContent = () => {
  const breakdown = window.dutiesPriceBreakdown;

  return (
    <>
      <article className="tw:px-4">
        <h2>{i18n("duties-modal.title")}</h2>
        <p>{i18n("duties-modal.description.1")}</p>
        <p>{i18n("duties-modal.description.2")}</p>
        {breakdown && (
          <>
            <hr class="tw:border-0 tw:border-b tw:border-fruugo-border-control tw:my-4" />
            <h3 class="tw:font-bold tw:text-lg">
              {i18n("duties-modal.heading")}
            </h3>
            <table>
              <tbody>
                {breakdown.itemPrice && (
                  <tr>
                    <td class="tw:pr-4 tw:rtl:pl-4 tw:rtl:pr-0">
                      {i18n("duties-modal.label.1")}
                    </td>
                    <td
                      class="tw:text-right"
                      data-testid="duties-modal-item-price"
                    >
                      {breakdown.itemPrice}
                    </td>
                  </tr>
                )}
                {breakdown.dutiesAndFees && (
                  <tr>
                    <td class="tw:pr-4 tw:rtl:pl-4 tw:rtl:pr-0">
                      {i18n("duties-modal.label.2")}
                    </td>
                    <td class="tw:text-right" data-testid="duties-modal-fees">
                      {breakdown.dutiesAndFees}
                    </td>
                  </tr>
                )}
                {breakdown.tax && (
                  <tr>
                    <td class="tw:pr-4 tw:rtl:pl-4 tw:rtl:pr-0">
                      {i18n("duties-modal.label.3")}{" "}
                      {breakdown.taxRate ? `(${breakdown.taxRate})` : ""}
                    </td>
                    <td class="tw:text-right" data-testid="duties-modal-tax">
                      {breakdown.tax}
                    </td>
                  </tr>
                )}
                {breakdown.total && (
                  <tr>
                    <td class="tw:pr-4 tw:rtl:pl-4 tw:rtl:pr-0">
                      {i18n("duties-modal.label.4")}
                    </td>
                    <td class="tw:text-right" data-testid="duties-modal-total">
                      {breakdown.total}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
        <hr class="tw:border-0 tw:border-b tw:border-fruugo-border-control tw:my-4" />
        <div class="tw:flex tw:justify-center tw:sm:justify-start">
          <a
            href="/help/detail/customs-charge"
            target="_blank"
            className="tw:underline tw:hover:no-underline tw:focus-visible:ring-2 tw:focus-visible:ring-offset-2 tw:focus-visible:ring-fruugo-blue-secondary"
          >
            {i18n("duties-modal.learn-more")}
          </a>
        </div>
      </article>
      <footer className="tw:bg-white tw:border-none tw:text-right tw:p-4 tw:rtl:text-left">
        <PrimaryButton
          onClick={() => closeModal()}
          variant="solid"
          cssClass="tw:w-full tw:sm:w-auto"
        >
          {i18n("modal.duties-and-taxes.button")}
        </PrimaryButton>
      </footer>
    </>
  );
};
